import React from "react";

export default function IdentificationDemandeur({
  values,
  setValue,
  errors,
  showSuggestions,
  setShowSuggestions,
  setHasSelected,
  filteredOptions,
  handleSelect,
  handleBlur,
  loadingUsers,
  errorUsers,
}) {
  return (
    <fieldset className="border border-gray-300 p-6 rounded">
      <legend className="block text-lg font-semibold bg-blue-100 px-4 py-2 leading-[1.6] rounded">
        Identification du demandeur
      </legend>
      <label className="block mt-4 relative">
        <span className="text-sm font-medium">Email</span>{" "}
        <span className="text-red-500">*</span>
        <input
          type="text"
          placeholder={
            loadingUsers
              ? "Chargement des utilisateurs..."
              : errorUsers
              ? "Erreur de chargement"
              : "Rechercher un email ou nom"
          }
          value={values.EmailDemandeurLabel || ""}
          onChange={(e) => {
            setShowSuggestions(true);
            setValue("EmailDemandeurLabel", e.target.value);
            setValue("uuidInitiator", "");
          }}
          onFocus={() => {
            setShowSuggestions(true);
            setHasSelected(false);
          }}
          onBlur={handleBlur}
          className={`mt-1 w-full border rounded px-3 py-2 ${
            errors.uuidInitiator ? "border-red-500" : "border-gray-300"
          }`}
          disabled={loadingUsers || !!errorUsers}
        />

        {loadingUsers && (
          <div className="absolute left-0 right-0 mt-1 text-gray-500 text-sm bg-white rounded px-2 py-1 shadow">
            Chargement des utilisateurs...
          </div>
        )}
        {errorUsers && (
          <div className="absolute left-0 right-0 mt-1 text-red-500 text-sm bg-white rounded px-2 py-1 shadow">
            {errorUsers}
          </div>
        )}

        {showSuggestions && !loadingUsers && !errorUsers && filteredOptions.length > 0 && (
          <ul className="absolute z-10 left-0 right-0 border mt-1 rounded bg-white max-h-40 overflow-y-auto shadow text-sm">
            {filteredOptions.map((option, i) => (
              <li
                key={option.uuid ? option.uuid : i}
                onMouseDown={() => handleSelect(option)}
                className="px-3 py-1 hover:bg-gray-100 cursor-pointer"
              >
                {option.prenom} {option.nom} ({option.email})
              </li>
            ))}
          </ul>
        )}

        {errors.uuidInitiator && (
          <p className="text-red-500 text-sm mt-1">
            {errors.uuidInitiator.message}
          </p>
        )}
      </label>
    </fieldset>
  );
}
